<div class="rounded-sm bg-secondary mb-4 p-3">
    <div class="modal-header">
        <h4 class="modal-title">{{dialogData!=null?dialogData.employeeName:''}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="row">
        <div class="col-md-4 text-center text-lg-left">
            <div class="btn-group btn-group-sm">
                <div [(viewDate)]="viewDate" [view]="view" class="btn btn-outline-primary" mwlCalendarPreviousView>
                    <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
                </div>
                <div [(viewDate)]="viewDate" class="btn d-flex align-items-center btn-primary" mwlCalendarToday>
                    <span class="btn-wrapper--label">Current Month</span>
                </div>
                <div [(viewDate)]="viewDate" [view]="view" class="btn btn-outline-primary" mwlCalendarNextView>
                    <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
                </div>
            </div>
        </div>
        <div class="col-md-4 d-flex text-center justify-content-center align-items-center py-3 py-lg-0">
            <h3 class="font-weight-bold font-size-lg mb-0">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
        </div>
        <div class="col">
            <div class="row">
                <span class="badge badge-primary badge-size badge-red h-auto py-0 px-3">&nbsp;&nbsp;</span>
                <h6 class="font-size-md mb-0">Available</h6>
            </div>
            <div class="row">
                <span class="badge badge-size badge-red h-auto py-0 px-3 booked" >&nbsp;&nbsp;</span>
                <h6 class="font-size-md mb-0">Booked</h6>
            </div>
            <div class="row">
                <span class="badge over-night-vailable badge-size badge-red h-auto py-0 px-3">&nbsp;&nbsp;</span>
                <h6 class="font-size-md mb-0">Over Night Available</h6>
            </div>
            <div class="row">
                    <span class="badge over-night-booked badge-size badge-red h-auto py-0 px-3">&nbsp;&nbsp;</span>
                    <h6 class="font-size-md mb-0">Over Night Booked</h6>
                </div>
        </div>
        <!-- <div class="col-md-4 text-center text-lg-right">
            <div class="btn-group btn-group-sm">
                <div (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month"
                    class="btn btn-primary">
                    Month
                </div>
                <div (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week"
                    class="btn btn-primary">
                    Week
                </div>
                <div (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day"
                    class="btn btn-primary">
                    Day
                </div>
            </div>
        </div> -->
    </div>
</div>
<mwl-calendar-month-view [events]="events" [viewDate]="viewDate" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)" (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)">
</mwl-calendar-month-view>